// @ts-nocheck
import { encodeJson as encodeJson_1, decodeJson as decodeJson_1, encodeBinary as encodeBinary_1, decodeBinary as decodeBinary_1, } from "./Goods";
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../runtime/json/scalar";
import { WireType, } from "../../../runtime/wire/index";
import { default as serialize, } from "../../../runtime/wire/serialize";
import { tsValueToWireValueFns, wireValueToTsValueFns, } from "../../../runtime/wire/scalar";
import { default as deserialize, } from "../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        selections: [],
        minSelection: "0",
        maxSelection: "0",
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    result.selections = value.selections.map(value => encodeJson_1(value));
    if (value.minSelection !== undefined)
        result.minSelection = tsValueToJsonValueFns.int64(value.minSelection);
    if (value.maxSelection !== undefined)
        result.maxSelection = tsValueToJsonValueFns.int64(value.maxSelection);
    return result;
}
export function decodeJson(value) {
    var _a, _b;
    const result = getDefaultValue();
    result.selections = (_b = (_a = value.selections) === null || _a === void 0 ? void 0 : _a.map((value) => decodeJson_1(value))) !== null && _b !== void 0 ? _b : [];
    if (value.minSelection !== undefined)
        result.minSelection = jsonValueToTsValueFns.int64(value.minSelection);
    if (value.maxSelection !== undefined)
        result.maxSelection = jsonValueToTsValueFns.int64(value.maxSelection);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    for (const tsValue of value.selections) {
        result.push([1, { type: WireType.LengthDelimited, value: encodeBinary_1(tsValue) }]);
    }
    if (value.minSelection !== undefined) {
        const tsValue = value.minSelection;
        result.push([2, tsValueToWireValueFns.int64(tsValue)]);
    }
    if (value.maxSelection !== undefined) {
        const tsValue = value.maxSelection;
        result.push([3, tsValueToWireValueFns.int64(tsValue)]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    collection: {
        const wireValues = wireMessage.filter(([fieldNumber]) => fieldNumber === 1).map(([, wireValue]) => wireValue);
        const value = wireValues.map((wireValue) => wireValue.type === WireType.LengthDelimited ? decodeBinary_1(wireValue.value) : undefined).filter(x => x !== undefined);
        if (!value.length)
            break collection;
        result.selections = value;
    }
    field: {
        const wireValue = wireFields.get(2);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.int64(wireValue);
        if (value === undefined)
            break field;
        result.minSelection = value;
    }
    field: {
        const wireValue = wireFields.get(3);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.int64(wireValue);
        if (value === undefined)
            break field;
        result.maxSelection = value;
    }
    return result;
}
